import GraphqlBuilder from 'utils/request/graphql/builder'
import _ from 'lodash'
import QueryTableUpdatedAt from "graphql/queries/QueryTableUpdatedAt";
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import HelperPlatform from 'utils/helper-platform'
import SecureStoreService from 'services/store/secure-store'
import { storeKeys } from 'services/store/keys'

export default class FetchUpdatedAt {
	
	static firstCallProcessed = false;
	
	static async fetch( { tables, parameters, callbackSuccess = null, callbackError = null, callbackStart = null, callbackCancelled = false } = {} ) {
		if( HelperPlatform.isWeb() && this.firstCallProcessed === true && store.getState().data[ dataConstants.APP_IS_FOCUSED ] === false ) {
			if( _.isFunction( callbackCancelled ) ){
				callbackCancelled();
			}
			return;
		}

		try {
			const employeeSession = await SecureStoreService.get( storeKeys.EMPLOYEE_SESSION );

			// Cache timers can outlive a session. This query is absent from the guest schema.
			if( _.isEmpty( employeeSession ) ) {
				if( _.isFunction( callbackCancelled ) ) {
					callbackCancelled();
				}
				return;
			}

			await new GraphqlBuilder()
				.addQuery( 'tables_updated_at', QueryTableUpdatedAt, { tables: tables, parameters: parameters } )
				.setResultPath( [ 'tables_updated_at', 'tables_updated_at' ], [] )
				.setOnStart( callbackStart )
				.setOnError( callbackError )
				.setOnSuccess( result => {
					this.firstCallProcessed = true;

					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( { updated_ats: result } );
					}
				})
				.execute();
		} catch( error ) {
			if( _.isFunction( callbackError ) ) {
				callbackError( error );
			}
		}
	}
}
